import React from 'react';

const RadialBarChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        stroke="#E0E7FF"
        strokeWidth="4"
        d="M40 52c12.15 0 22-9.85 22-22S52.15 8 40 8s-22 9.85-22 22 9.85 22 22 22Z"
      ></path>
      <path
        stroke="#3B82F6"
        strokeLinecap="round"
        strokeWidth="4"
        d="M40 8a22 22 0 1 1-20.92 15.2"
      ></path>
      <path
        stroke="#E0E7FF"
        strokeWidth="4"
        d="M40 46c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
      ></path>
      <path
        stroke="#818CF8"
        strokeLinecap="round"
        strokeWidth="4"
        d="M40 14a16.001 16.001 0 1 1-9.4 28.94"
      ></path>
      <path
        stroke="#E0E7FF"
        strokeWidth="4"
        d="M40 40c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z"
      ></path>
      <path
        stroke="#38BDF8"
        strokeLinecap="round"
        strokeWidth="4"
        d="M40 20a10 10 0 0 1 3.09 19.51"
      ></path>
    </svg>
  );
};

export default RadialBarChartIcon;
